webpackJsonp([1520471504850],{

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n                background-image: url(", ");\n                background-size: cover;\n                background-position: center center;\n                width: 100%;\n                height: 180px;\n                border-top-left-radius: 12px;\n                border-top-right-radius: 12px;\n"], ["\n                background-image: url(", ");\n                background-size: cover;\n                background-position: center center;\n                width: 100%;\n                height: 180px;\n                border-top-left-radius: 12px;\n                border-top-right-radius: 12px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledImage = _styledComponents2.default.div(_templateObject, function (props) {
	                return "/" + props.imageUrl;
	});
	
	var HeaderImage = function HeaderImage(_ref) {
	                var imageUrl = _ref.imageUrl,
	                    children = _ref.children;
	                return _react2.default.createElement(
	                                StyledImage,
	                                { imageUrl: imageUrl },
	                                " ",
	                                children,
	                                " "
	                );
	};
	
	exports.default = HeaderImage;
	module.exports = exports["default"];

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\npadding-bottom: 1rem;\n@media screen and (min-width: 40em) {\n   flex: 0 1 calc(50% - 1em);\n   min-width: 290px;\n   padding-bottom: 1em;\n   }\n   \n   @media screen and (min-width: 60em) {\n     flex: 0 1 calc(25% - 1em);\n}\n"], ["\npadding-bottom: 1rem;\n@media screen and (min-width: 40em) {\n   flex: 0 1 calc(50% - 1em);\n   min-width: 290px;\n   padding-bottom: 1em;\n   }\n   \n   @media screen and (min-width: 60em) {\n     flex: 0 1 calc(25% - 1em);\n}\n"]);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledContainer = _styledComponents2.default.div(_templateObject);
	
	var StyledCardContainer = function StyledCardContainer(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    StyledContainer,
	    null,
	    " ",
	    children,
	    " "
	  );
	};
	
	exports.default = StyledCardContainer;
	module.exports = exports["default"];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n@media screen and (min-width: 40em) {\n   display: flex;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   }\n"], ["\n@media screen and (min-width: 40em) {\n   display: flex;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _container = __webpack_require__(23);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _base = __webpack_require__(44);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _header = __webpack_require__(46);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _content = __webpack_require__(45);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _HeaderImage = __webpack_require__(28);
	
	var _HeaderImage2 = _interopRequireDefault(_HeaderImage);
	
	var _conferenceDate = __webpack_require__(62);
	
	var _conferenceDate2 = _interopRequireDefault(_conferenceDate);
	
	var _TitleLayout = __webpack_require__(20);
	
	var _TitleLayout2 = _interopRequireDefault(_TitleLayout);
	
	var _StyledContainer = __webpack_require__(61);
	
	var _StyledContainer2 = _interopRequireDefault(_StyledContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledDiv = _styledComponents2.default.div(_templateObject);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _container2.default,
	    null,
	    _react2.default.createElement(
	      StyledDiv,
	      null,
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          _base2.default,
	          { interactive: false },
	          _react2.default.createElement(
	            _header2.default,
	            null,
	            _react2.default.createElement(_HeaderImage2.default, { imageUrl: "training/java.jpg" })
	          ),
	          _react2.default.createElement(
	            _content2.default,
	            null,
	            _react2.default.createElement(
	              _TitleLayout2.default,
	              null,
	              "Java 8 Training"
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(_conferenceDate2.default, { date: "August 2016", event: "Client Training", location: "Northampton, UK" }),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              null,
	              "3 day in house training course teaching students how to use Java 8 features, SOLID principles and TDD."
	            ),
	            _react2.default.createElement("br", null)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          _base2.default,
	          { interactive: false },
	          _react2.default.createElement(
	            _header2.default,
	            null,
	            _react2.default.createElement(_HeaderImage2.default, { imageUrl: "training/elixir.jpg" })
	          ),
	          _react2.default.createElement(
	            _content2.default,
	            null,
	            _react2.default.createElement(
	              _TitleLayout2.default,
	              null,
	              "Elixir for Beginners"
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(_conferenceDate2.default, { date: "May 2016", event: "Client Training", location: "London, UK" }),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              null,
	              "3 day in house training course introducing students to the key feature of Elixir and functional programming using TDD."
	            ),
	            _react2.default.createElement("br", null)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          _base2.default,
	          { interactive: false },
	          _react2.default.createElement(
	            _header2.default,
	            null,
	            _react2.default.createElement(_HeaderImage2.default, { imageUrl: "training/agile.jpg" })
	          ),
	          _react2.default.createElement(
	            _content2.default,
	            null,
	            _react2.default.createElement(
	              _TitleLayout2.default,
	              null,
	              " Skills for the Agile Developer"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_conferenceDate2.default, { date: "May 2015", event: "Client Training", location: "London, UK" }),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(_conferenceDate2.default, { date: "June 2015", event: "Client Training", location: "New York, USA" }),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(_conferenceDate2.default, { date: "June 2015", event: "Client Training", location: "Nashville, USA" }),
	              _react2.default.createElement("br", null),
	              "2 day in house training course introducing developers to Agile programming techniques such as pair programming, TDD, continuous delivery, & SOLID design principles."
	            ),
	            _react2.default.createElement("br", null)
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n@media screen and (min-width: 40em) {\n   display: flex;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   }\n"], ["\n@media screen and (min-width: 40em) {\n   display: flex;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: black;\n"], ["\n  color: black;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _container = __webpack_require__(23);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _base = __webpack_require__(44);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _header = __webpack_require__(46);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _content = __webpack_require__(45);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _HeaderImage = __webpack_require__(28);
	
	var _HeaderImage2 = _interopRequireDefault(_HeaderImage);
	
	var _TitleLayout = __webpack_require__(20);
	
	var _TitleLayout2 = _interopRequireDefault(_TitleLayout);
	
	var _conferenceDate = __webpack_require__(62);
	
	var _conferenceDate2 = _interopRequireDefault(_conferenceDate);
	
	var _StyledContainer = __webpack_require__(61);
	
	var _StyledContainer2 = _interopRequireDefault(_StyledContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledDiv = _styledComponents2.default.div(_templateObject);
	
	var StyledLink = _styledComponents2.default.a(_templateObject2);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _container2.default,
	    null,
	    _react2.default.createElement(
	      StyledDiv,
	      null,
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { href: "http://www.elixirconf.eu/elixirconf2017/georgina-mcfadyen",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "workshops/Barcalona.jpeg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                " Microservices Under the Umbrella "
	              ),
	              _react2.default.createElement(_conferenceDate2.default, { event: "Elixir EU Workshop", date: "May 2017", location: "Barcelona, Spain" }),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                null,
	                "One day workshop taking students through how to deploy different OTP apps using umbrella applications using TDD and Distributed Erlang."
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { href: "https://www.meetup.com/8LU-London/events/237311782/",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "workshops/code.jpg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                " 8LU Legacy Code Retreat "
	              ),
	              _react2.default.createElement(_conferenceDate2.default, { event: "8LU Meetup", date: "February 2017", location: "London, UK" }),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                null,
	                "One day workshop taking students through different refactoring techniques on a legacy code base."
	              ),
	              _react2.default.createElement("br", null)
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _StyledContainer2.default,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { href: "https://www.meetup.com/london-software-craftsmanship/events/235776594",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "workshops/createYourOwnTestFramework.jpeg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                " Create Your Own Test Framework "
	              ),
	              _react2.default.createElement(_conferenceDate2.default, { event: "London Software Craftsmanship Meetup", date: "December 2016",
	                location: "London, UK" }),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                null,
	                "Practical workshop where students explored the fundamentals of a test framework by extracting their own from the code they were writing."
	              ),
	              _react2.default.createElement("br", null)
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n  vertical-align: middle;\n  font-weight: bold;\n  text-align: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n  vertical-align: middle;\n  font-weight: bold;\n  text-align: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n padding: 8px;\n"], ["\n padding: 8px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TitleLayout = _styledComponents2.default.div(_templateObject);
	var Layout = _styledComponents2.default.div(_templateObject2);
	var TitleContent = function TitleContent(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    Layout,
	    null,
	    _react2.default.createElement(
	      TitleLayout,
	      null,
	      children
	    )
	  );
	};
	
	exports.default = TitleContent;
	module.exports = exports["default"];

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConferenceDetails = function ConferenceDetails(_ref) {
	  var event = _ref.event,
	      location = _ref.location,
	      date = _ref.date;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      null,
	      "\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFEB ",
	      event
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      "\uD83D\uDCC5 ",
	      date
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      "\uD83C\uDF0D ",
	      location
	    )
	  );
	};
	
	exports.default = ConferenceDetails;
	module.exports = exports["default"];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _container = __webpack_require__(23);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _WorkshopCards = __webpack_require__(214);
	
	var _WorkshopCards2 = _interopRequireDefault(_WorkshopCards);
	
	var _TrainingCards = __webpack_require__(213);
	
	var _TrainingCards2 = _interopRequireDefault(_TrainingCards);
	
	var _TitleLayout = __webpack_require__(20);
	
	var _TitleLayout2 = _interopRequireDefault(_TitleLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _container2.default,
	    null,
	    _react2.default.createElement(
	      _TitleLayout2.default,
	      null,
	      "Workshops "
	    ),
	    _react2.default.createElement(_WorkshopCards2.default, null),
	    _react2.default.createElement(
	      _TitleLayout2.default,
	      null,
	      "Training"
	    ),
	    _react2.default.createElement(_TrainingCards2.default, null)
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-training-js-08ef00a0c8c09c5c88a6.js